export default __webpack_public_path__ + "static/media/image-study-board-1-m@2x.f50a97e6.png";